/* eslint-disable max-len, indent, sonarjs/no-duplicate-string */

const hasContext = (/** @type {string} */context) => window.contexts.includes(context);

import widgetsMgr from 'widgets/widgetsMgr';

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('account') && hasContext('google-avs'),
    load: () => Promise.all([
        import(/* webpackChunkName: 'account.google.avs' */ './widgets/forms/GoogleAddressBookForm').then(d => d.default),
        import(/* webpackChunkName: 'account.google.avs' */ './widgets/google/AddressVerificationMixin').then(d => d.default),
        import(/* webpackChunkName: 'account.google.avs' */ './widgets/forms/MatchedAddressesModal').then(d => d.default),
        import(/* webpackChunkName: 'account.google.avs' */ 'widgets/checkout/RadioSelector').then(d => d.default)
    ]).then(deps => {
        const [
            GoogleAddressBookForm,
            AddressVerificationMixin,
            MatchedAddressesModal,
            RadioSelector
        ] = deps;

        return {
            listId: 'account.google.avs',
            widgetsDefinition: () => [
                ['addressForm', AddressVerificationMixin, 'addressForm'],
                ['addressForm', GoogleAddressBookForm, 'addressForm'],
                ['matchedAddressesModal', MatchedAddressesModal],
                ['radioSelector', RadioSelector, 'inputRadio']
            ]
        };
    })
});

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('checkout') && hasContext('google-avs'),
    load: () => Promise.all([
        import(/* webpackChunkName: 'checkout.google.avs' */ './widgets/checkout/GoogleCheckoutMgr').then(d => d.default),
        import(/* webpackChunkName: 'checkout.google.avs' */ './widgets/google/AddressVerificationMixin').then(d => d.default),
        import(/* webpackChunkName: 'checkout.google.avs' */ './widgets/checkout/GoogleAddressCheckoutForm').then(d => d.default),
        import(/* webpackChunkName: 'checkout.google.avs' */ './widgets/forms/GoogleAddressBookForm').then(d => d.default),
        import(/* webpackChunkName: 'checkout.google.avs' */ './widgets/forms/MatchedAddressesModal').then(d => d.default)
    ]).then(deps => {
        const [
            GoogleCheckoutMgr,
            AddressVerificationMixin,
            GoogleAddressCheckoutForm,
            GoogleAddressBookForm,
            MatchedAddressesModal
        ] = deps;

        return {
            listId: 'checkout.google.avs',
            widgetsDefinition: () => [
                ['checkoutMgr', GoogleCheckoutMgr, 'checkoutMgr'],
                ['addressCheckoutForm', AddressVerificationMixin, 'addressCheckoutForm'],
                ['shippingForm', GoogleAddressCheckoutForm, 'shippingForm'],
                ['billingForm', GoogleAddressCheckoutForm, 'billingForm'],
                ['billingsCorrectionForm', AddressVerificationMixin, 'billingsCorrectionForm'],
                ['billingsCorrectionForm', GoogleAddressBookForm, 'billingsCorrectionForm'],
                ['matchedAddressesModal', MatchedAddressesModal]
            ]
        };
    })
});
